
import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { withApollo } from 'react-apollo';
import { 
    withStyles,
    Button
  } from '@material-ui/core';
import clsx from 'clsx'
import completeImage from '../../../img/Complete-Onboarding.png'
import '../../../scss/component/onboarding/company_profile.scss'

  const useStyles = (theme) => ({
    root: {
      width: '100%',
    },
    button: {
      marginRight: theme.spacing(1),
    },
    input: {
        width: '100%',
    },
    nextButton: {
        background: '#5B9FAB',
        left: '29%',
        '&:hover': {
          background: '#5B9FAB',
          borderColor: '#5B9FAB',
          color: 'white'
        },
    }
  });

class CompletePage extends PureComponent {
  constructor (props) {
    super(props)
    this._isMounted = false;
    this.state = {}
    this.handleComplete = this._handleComplete.bind(this);
  }

    render(){
        const {classes} = this.props;
        return(
            <div id="#modal_content">
                <div id="complete_onboarding">
                    <img src={completeImage} alt="Onboarding finished!"/>
                    <h1 id="centerHeading">Awesome</h1>
                    <h3 id="welcomeText">Your Posture Account is ready. It's time to hit your compliance goals</h3><br/><br/>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={()=>{this.handleComplete()}}
                      className={clsx(classes.nextButton,classes.button)}
                    >
                      Go to Posture
                    </Button>
                </div>
 
            </div>
        )
    }
  
    _handleComplete(){
      this.props.history.push('/app/getting-started');
    }
}

export default withRouter(withApollo((withStyles(useStyles)(CompletePage))))


// WEBPACK FOOTER //
// ./src/components/onboarding/components/CompletePage.js